<app-quotes-subsections-toggles [activeTab]="activeTab.Invoices" [isOnAccountsPage]="isOnAccountsPage"></app-quotes-subsections-toggles>

<div *appIsDesktop id="invoicesListMainContainer" class="container">
  <ds-paper id="invoicesListPaper" borderRadius="radius_S" insidePaddingTop="top-spacing_L" insidePaddingBottom="bottom-spacing_L"
    insidePaddingLeft="left-spacing_XL" insidePaddingRight="right-spacing_XL">
    @if (dataLoaded.templateValues) {
      <app-quotes-subsections-filter-form (resetSort)="resetSortIndicator($event)"
        (resetPage)="resetPage()" [getListMethod]="getListMethod" [sortKey]="invoiceKey" [label]="appStrings.menu_Invoices"
        [isOnAccountsPage]="isOnAccountsPage" [bpNumber]="bpNumber" [activeTab]="activeTab.Invoices">
      </app-quotes-subsections-filter-form>
    }

    @if (isLoading) {
      <div id="loadingContainer" class="overlay full">
        <p class="text-center">{{ appStrings.pleaseWait }}</p>
        <ds-progress-spinner id="invoicesLoading"></ds-progress-spinner>
      </div>
    }

    <div id="invoiceListContainer">
      <div id="invoiceListTableContainer" class="table-container">
        <div [hidden]="!totalRecords">
          <ds-table id="invoiceTableList" mat-table [dataSource]="invoiceList"
            (matSortChange)="sortData($event)" matSort [displayedColumns]="displayedColumns" [isWithRadio]="isWithRadio">
            <!-- Sales Representative -->
            <ng-container matColumnDef="salesRepresentative">
              <th id="invoiceSalesRepresentative" mat-header-cell *matHeaderCellDef mat-sort-header>
              {{ appStrings.invoiceDetails_salesRepresentative }}</th>
              <td [id]="'salesRepresentative_'+rowNum" mat-cell *matCellDef="let invoice;let rowNum = dataIndex">
                {{ invoice.salesRepresentative }}
              </td>
            </ng-container>
            <!-- Customer Name -->
            <ng-container matColumnDef="name">
              <th id="invoiceName" mat-header-cell *matHeaderCellDef mat-sort-header>
                {{ appStrings.invoiceDetails_name }}
              </th>
              <td [id]="'customerName_'+rowNum" mat-cell *matCellDef="let invoice;let rowNum = dataIndex">
                {{ invoice.customerName }}
              </td>
            </ng-container>
            <!-- BP Number -->
            <ng-container matColumnDef="bpNumber">
              <th id="invoiceBpNumber" mat-header-cell *matHeaderCellDef>
                {{ appStrings.invoiceDetails__bpNumber }}
              </th>
              <td [id]="'bpNumber_'+rowNum" mat-cell *matCellDef="let invoice;let rowNum = dataIndex">
                {{ invoice.bpNumber }}
              </td>
            </ng-container>
            <!-- Invoice Number -->
            <ng-container matColumnDef="invoiceNumber">
              <th id="invoiceNumber" mat-header-cell *matHeaderCellDef>
                {{ appStrings.invoiceDetails_number }}
              </th>
              <td [id]="'invoiceNumber_'+rowNum" mat-cell *matCellDef="let invoice;let rowNum = dataIndex">
                {{ invoice.invoiceNumber }}
              </td>
            </ng-container>
            <!-- Invoice Date -->
            <ng-container matColumnDef="invoiceDate">
              <th id="invoiceDate" mat-header-cell *matHeaderCellDef mat-sort-header>
                {{ appStrings.invoiceDetails_orderDate }}
              </th>
              <td [id]="'invoiceDate_'+rowNum" mat-cell *matCellDef="let invoice;let rowNum = dataIndex">
                {{ invoice.invoiceDate | date: dateFormat }}
              </td>
            </ng-container>
            <!-- PO Number -->
            <ng-container matColumnDef="poNumber">
              <th id="invoicePoNumber" mat-header-cell *matHeaderCellDef mat-sort-header>
                {{ appStrings.invoiceDetails_poNumber }}
              </th>
              <td [id]="'poNumber_'+rowNum" mat-cell *matCellDef="let invoice;let rowNum = dataIndex">
                {{ invoice.poNumber }}
              </td>
            </ng-container>
            <!-- Total Amount -->
            <ng-container matColumnDef="totalAmount">
              <th id="invoiceTotalAmount" mat-header-cell *matHeaderCellDef mat-sort-header class="total-header">
                {{ appStrings.invoiceDetails_totalAmount }}
              </th>
              <td [id]="'totalAmount_'+rowNum" mat-cell *matCellDef="let invoice;let rowNum = dataIndex" class="total">
                {{ invoice.totalAmount | currency: invoice.currency }}
              </td>
            </ng-container>
            <!-- Print -->
            <ng-container matColumnDef="print">
              <th id="invoicePrint" mat-header-cell *matHeaderCellDef></th>
              <td [id]="'printCell_' + rowNum" mat-cell *matCellDef="let invoice;let rowNum = dataIndex">
                <ds-button size="medium" type="tertiary" variant="label-icon" icon="print-outlined"
                  iconStyle="material-icons-outlined" [id]="'print_' + rowNum" (onClick)="printInvoice(invoice.invoiceNumber)"
                  label="{{ appStrings.button_print }}" iconPosition="left">
                </ds-button>
              </td>
            </ng-container>
            <!-- View -->
            <ng-container matColumnDef="view">
              <th id="invoiceView" mat-header-cell *matHeaderCellDef></th>
              <td mat-cell *matCellDef="let invoice;let rowNum = dataIndex">
                <a [id]="'viewCell_' + rowNum" [routerLink]="['/invoices', invoice.invoiceNumber, { customerId: customerId }]">
                  <ds-button size="medium" type="tertiary" variant="label-icon" icon="visibility-outlined"
                    iconStyle="material-icons-outlined" label="{{ appStrings.button_view }}"
                    iconPosition="left" [id]="'view_' + rowNum">
                  </ds-button>
                </a>
              </td>
            </ng-container>
          </ds-table>
        </div>

        @if (!totalRecords && !isLoading && !isPartialLoading) {
          <div id="emptyOrdersList" class="no-results">
            {{ appStrings.noEntriesFound }}
          </div>
        }

        @if (isPartialLoading) {
          <div id="loadingPartialResults" class="searching-row row-loading">
            <span id="hourglassLoading" class="crm-industrial-font icon-hourglass"></span>
            {{ appStrings.loading_stillSearching }}
          </div>
        }
      </div>

      @if (totalRecords) {
        <div id="paginationContainerDesktop" class="pagination-container-desktop">
          <div id="invoiceListPaginatorCount" class="page-count">
            @if (!isLoading && !isPartialLoading) {
              <div id="pageCountText">
                <b id="pageRangeText">{{ pageOffset + 1 }} - {{ pageOffset + (invoiceList?.length ?? 0) }}</b> {{appStrings.pagination_of}} <b id="totalRecordsText">{{ totalRecords }}</b>
              </div>
            }
          </div>
          <div id="invoiceListPaginator">
            <ds-pagination
              [totalPages]="totalPages"
              paginationDisplay="large"
              buttonTypes="nextPrevFirstLast"
              (pageChanged)="loadPage($event)"
            ></ds-pagination>
          </div>
          <div class="flex-item-2"></div>
        </div>
      }
    </div>
  </ds-paper>
</div>


<div *appIsMobile id="invoicesListMainContainer-mobile" class="mobile">
  @if (isLoading) {
    <div class="overlay full" id="invoices-mobile-loadingSpinner">
      <p class="text-center">{{ appStrings.pleaseWait }}</p>
      <ds-progress-spinner progress_mode="indeterminate"></ds-progress-spinner>
    </div>
  }

  @if (dataLoaded.templateValues) {
    <app-quotes-subsections-filter-form (resetSort)="resetSortIndicator($event)"
      (resetPage)="resetPage()" [getListMethod]="getListMethod" [sortKey]="invoiceKey" [label]="appStrings.menu_Invoices"
      [isOnAccountsPage]="isOnAccountsPage" [bpNumber]="bpNumber" [activeTab]="activeTab.Invoices">
    </app-quotes-subsections-filter-form>
  }

  @for (invoice of invoiceList; track invoice; let i = $index) {
    <mat-expansion-panel [id]="'invoiceCard_'+i" class="mobile-card two-columns tall blue-border" [expanded]="false">
      <mat-expansion-panel-header [id]="'invoiceCardHeader_'+i">
        <mat-panel-title id="invoice-card-header-container" class="card-header-container">
          <span [id]="'invoice-card-header_'+i" class="card-header">
            <span [id]="'invoice-card-title_'+i" class="title">
              {{ invoice.invoiceNumber ?? '-'}}
            </span>
            <span [id]="'invoice-card-subtitle_'+i" class="subtitle">
              {{ invoice.totalAmount | currency: invoice.currency }}
            </span>
          </span>
          <span [id]="'invoice-card-header-action_'+i" class="card-header-action">
            <a [id]="'viewCell_' + i" [routerLink]="['/invoices', invoice.invoiceNumber, { customerId: customerId }]">
              <ds-button size="medium" type="tertiary" variant="icon-only" icon="visibility-outlined"
                iconStyle="material-icons-outlined" [id]="'view_' + i">
              </ds-button>
            </a>
          </span>
        </mat-panel-title>
      </mat-expansion-panel-header>
      <ds-divider></ds-divider>
      <div [id]="'invoiceCardContent_'+i" [id]="'invoiceCardContent_'+i" class="content">
        <div [id]="'invoiceCardRow1_'+i" class="row">
          <div [id]="'invoiceCardRow1Col1_'+i" class="column">
            <typography [id]="'invoiceDate_label_'+i" class="label" variant="caption-2" weight="regular"> {{ appStrings.invoiceDetails_orderDate }} </typography>
            <typography [id]="'invoiceDate_'+i" variant="body-2" weight="medium"> {{ invoice.invoiceDate | date: dateFormat }} </typography>
          </div>
          <div [id]="'invoiceCardRow1Col2_'+i" class="column">
            <typography [id]="'invoicePoNumber_label_'+i" class="label" variant="caption-2" weight="regular"> {{ appStrings.invoiceDetails_poNumber }} </typography>
            <typography [id]="'invoicePoNumber_'+i" variant="body-2" weight="medium"> {{ invoice.poNumber }} </typography>
          </div>
        </div>
      </div>
      <ds-divider></ds-divider>
      <div [id]="'invoiceCardActions_'+i" class="card-actions">
        <ds-button size="medium" type="secondary" variant="label-icon" icon="print" iconStyle="material-icons-outlined" [id]="'print_'+i"
          (onClick)="printInvoice(invoice.invoiceNumber)" label="{{ appStrings.button_print }}" iconPosition="left">
        </ds-button>
      </div>
    </mat-expansion-panel>
  }
  @if (totalRecords > 0) {
    <div id="paginationContainerMobile" class="pagination-container">
      <ds-paper id="invoiceListMobilePaginationPaper" elevation="elevation_none" borderRadius="radius_S" outline="outlined" insidePaddingTop="top-spacing_S" insidePaddingBottom="bottom-spacing_S">
        <div id="mobilePagination" class="pagination">
          <ds-pagination
            [totalPages]="totalPages"
            paginationDisplay="small"
            buttonTypes="nextPrevFirstLast"
            (pageChanged)="loadPage($event)"
          ></ds-pagination>
        </div>
      </ds-paper>
    </div>
  }
  @if (!totalRecords && !isLoading && !isPartialLoading) {
    <div id="emptyInvoicesList" class="no-results">
      {{ appStrings.noEntriesFound }}
    </div>
  }
</div>